// Mock data for MidSkale website

export const caseStudies = [
  {
    id: 1,
    client: "Fortune 500 Manufacturing Co.",
    industry: "Manufacturing",
    service: "Oracle ERP Implementation",
    challenge: "Legacy systems causing operational inefficiencies and data silos across 15 plants",
    solution: "Complete Oracle Cloud ERP implementation with custom integrations",
    results: [
      "40% reduction in operational costs",
      "Real-time visibility across all facilities",
      "3-month faster implementation than industry average"
    ],
    duration: "8 months",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80"
  },
  {
    id: 2,
    client: "Global Retail Chain",
    industry: "Retail",
    service: "NetSuite + AI Chatbot",
    challenge: "Disconnected inventory management and poor customer service response times",
    solution: "NetSuite ERP integration with custom AI-powered customer service chatbot",
    results: [
      "95% customer query resolution rate",
      "60% reduction in support ticket volume",
      "Unified inventory across 200+ locations"
    ],
    duration: "6 months",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80"
  },
  {
    id: 3,
    client: "Healthcare Technology Startup",
    industry: "Healthcare",
    service: "Custom Software Development",
    challenge: "Needed HIPAA-compliant patient management system from scratch",
    solution: "Built secure cloud-based platform with AI-driven appointment scheduling",
    results: [
      "Processed 50K+ patient records securely",
      "100% HIPAA compliance achieved",
      "Reduced appointment no-shows by 45%"
    ],
    duration: "10 months",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80"
  },
  {
    id: 4,
    client: "Financial Services Provider",
    industry: "Finance",
    service: "JD Edwards Upgrade & Technical Staffing",
    challenge: "Outdated JD Edwards system and shortage of specialized technical resources",
    solution: "System upgrade to latest version plus placement of 12 certified JD Edwards consultants",
    results: [
      "Zero downtime during migration",
      "Enhanced security and compliance",
      "Reduced hiring time by 70%"
    ],
    duration: "12 months",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80"
  },
  {
    id: 5,
    client: "E-commerce Platform",
    industry: "Technology",
    service: "Data Engineering & Analytics",
    challenge: "Massive data growth with no actionable insights for business decisions",
    solution: "Built data warehouse with real-time analytics dashboard and ML-powered forecasting",
    results: [
      "Processing 10M+ transactions daily",
      "Predictive analytics improving sales by 28%",
      "Real-time business intelligence"
    ],
    duration: "5 months",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
  },
  {
    id: 6,
    client: "Logistics Company",
    industry: "Logistics",
    service: "Process Automation & AI",
    challenge: "Manual routing and scheduling causing delays and increased fuel costs",
    solution: "AI-powered route optimization system with automated dispatch",
    results: [
      "35% reduction in fuel costs",
      "50% faster delivery times",
      "90% automation of scheduling tasks"
    ],
    duration: "7 months",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80"
  }
];

export const services = [
  {
    id: 1,
    title: "ERP Consulting",
    description: "Expert consulting for Oracle ERP, NetSuite, and JD Edwards. From implementation to optimization, we deliver enterprise solutions that scale.",
    features: [
      "Oracle Cloud ERP Implementation",
      "NetSuite Customization & Integration",
      "JD Edwards Upgrades & Support",
      "System Integration & Migration",
      "Training & Change Management"
    ],
    icon: "database"
  },
  {
    id: 2,
    title: "Technical Resource Hiring",
    description: "Access top-tier technical talent on-demand. We provide specialized ERP consultants, developers, and engineers for contract or full-time roles.",
    features: [
      "Certified ERP Consultants",
      "Cloud Architecture Specialists",
      "Full-Stack Developers",
      "Remote & Onsite Options",
      "Managed Team Services"
    ],
    icon: "users"
  },
  {
    id: 3,
    title: "Custom Software & AI",
    description: "Build intelligent applications that transform your business. From AI chatbots to enterprise automation, we bring your vision to life.",
    features: [
      "AI Chatbot Development",
      "Web & Mobile Apps",
      "Process Automation",
      "Data Engineering & Analytics",
      "No-Code/Low-Code Solutions"
    ],
    icon: "code"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Deep ERP Expertise",
    description: "15+ years of experience with Oracle, NetSuite, and JD Edwards implementations across industries.",
    icon: "award"
  },
  {
    id: 2,
    title: "Agile Engagement",
    description: "Flexible engagement models that adapt to your needs - from project-based to dedicated teams.",
    icon: "zap"
  },
  {
    id: 3,
    title: "High-Quality Talent",
    description: "Access to pre-vetted, certified professionals with proven track records in enterprise systems.",
    icon: "star"
  },
  {
    id: 4,
    title: "Fast Delivery",
    description: "Accelerated timelines without compromising quality. We deliver results 30% faster than industry average.",
    icon: "rocket"
  },
  {
    id: 5,
    title: "Proven Track Record",
    description: "200+ successful implementations with 98% client satisfaction rate across Fortune 500 companies.",
    icon: "check-circle"
  },
  {
    id: 6,
    title: "Global Support",
    description: "24/7 support with teams across multiple time zones ensuring your systems run smoothly.",
    icon: "globe"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    position: "CTO, TechCorp Industries",
    company: "Fortune 500 Manufacturing",
    content: "MidSkale transformed our entire operation with their Oracle ERP implementation. The team's expertise and dedication were exceptional.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    position: "VP of Operations",
    company: "Global Retail Chain",
    content: "The technical talent MidSkale provided was exactly what we needed. They understood our NetSuite environment and delivered beyond expectations.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    position: "CEO, HealthTech Solutions",
    company: "Healthcare Technology",
    content: "Their custom software development and AI integration capabilities are world-class. MidSkale helped us launch 3 months ahead of schedule.",
    rating: 5
  }
];